import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button, Center, Group, Stack, Text, Title } from '@mantine/core';

type Props = { children: ReactNode };
type State = { error: Error | null };

// 전역 안전망: 하위 트리의 렌더 에러를 잡아 백지 대신 메시지+복구 액션 표시.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <Center h="100vh" p="lg">
          <Stack gap="sm" align="center" maw={520}>
            <Title order={2}>문제가 발생했습니다</Title>
            <Text size="sm" c="dimmed" ta="center" style={{ wordBreak: 'break-word' }}>
              {this.state.error.message}
            </Text>
            <Group mt="sm">
              <Button variant="default" onClick={() => window.location.assign('/')}>
                홈으로
              </Button>
              <Button onClick={() => window.location.reload()}>새로고침</Button>
            </Group>
          </Stack>
        </Center>
      );
    }
    return this.props.children;
  }
}
